<template>
  <section class="dashboard-page">
    <section
      class="dashboard-stats"
      aria-label="运营指标"
    >
      <article class="metric-card">
        <div class="metric-card__heading">
          <span>今日订单数</span>
          <span
            class="metric-card__icon metric-card__icon--green"
            aria-hidden="true"
          >▣</span>
        </div>
        <strong class="metric-card__value">—</strong>
        <span class="metric-card__hint">暂无统计数据</span>
      </article>

      <article class="metric-card">
        <div class="metric-card__heading">
          <span>待处理退款</span>
          <span
            class="metric-card__icon metric-card__icon--orange"
            aria-hidden="true"
          >↩</span>
        </div>
        <strong class="metric-card__value">—</strong>
        <span class="metric-card__hint metric-card__hint--warning">暂无待处理数据</span>
      </article>

      <article class="metric-card">
        <div class="metric-card__heading">
          <span>今日销售额</span>
          <span
            class="metric-card__icon metric-card__icon--green"
            aria-hidden="true"
          >¥</span>
        </div>
        <strong class="metric-card__value">—</strong>
        <span class="metric-card__hint">暂无金额统计</span>
      </article>

      <article class="metric-card">
        <div class="metric-card__heading">
          <span>新增定制咨询</span>
          <span
            class="metric-card__icon metric-card__icon--green"
            aria-hidden="true"
          >▱</span>
        </div>
        <strong class="metric-card__value">—</strong>
        <span class="metric-card__hint">暂无咨询统计</span>
      </article>
    </section>

    <section class="dashboard-main-grid">
      <article class="dashboard-panel dashboard-panel--orders">
        <header class="dashboard-panel__header">
          <div>
            <h2>最近订单明细</h2>
            <p class="muted">
              订单数据接入后将在此处显示。
            </p>
          </div>
          <span class="dashboard-panel__link">数据待接入</span>
        </header>

        <div class="dashboard-table-placeholder">
          <div class="dashboard-table-placeholder__head">
            <span>订单编号</span>
            <span>产品名称及规格</span>
            <span>客户名称</span>
            <span>订单金额</span>
            <span>当前状态</span>
          </div>
          <div class="empty-state empty-state--table">
            <span
              class="empty-state__mark"
              aria-hidden="true"
            >—</span>
            <strong>暂无订单数据</strong>
            <p>
              当前 Dashboard 没有订单统计接口，暂不展示模拟订单。
            </p>
          </div>
        </div>
      </article>

      <div class="dashboard-side-grid">
        <article class="dashboard-panel dashboard-panel--warning">
          <header class="dashboard-panel__header">
            <h2>
              <span
                class="dashboard-panel__icon dashboard-panel__icon--orange"
                aria-hidden="true"
              >!</span>
              库存低水位预警
            </h2>
            <span class="dashboard-panel__status">待接入</span>
          </header>
          <div class="empty-state">
            <span
              class="empty-state__mark"
              aria-hidden="true"
            >—</span>
            <strong>暂无库存预警</strong>
            <p>
              接入库存统计后显示需要关注的 SKU。
            </p>
          </div>
        </article>

        <article class="dashboard-panel dashboard-panel--consultation">
          <header class="dashboard-panel__header">
            <h2>
              <span
                class="dashboard-panel__icon dashboard-panel__icon--green"
                aria-hidden="true"
              >◌</span>
              最新定制需求评估
            </h2>
            <span class="dashboard-panel__status">待接入</span>
          </header>
          <div class="empty-state">
            <span
              class="empty-state__mark"
              aria-hidden="true"
            >—</span>
            <strong>暂无定制咨询</strong>
            <p>
              接入咨询数据后显示最新客户需求。
            </p>
          </div>
        </article>
      </div>
    </section>
  </section>
</template>

<style scoped>
.dashboard-page {
  display: grid;
  width: min(100%, 1280px);
  gap: 24px;
  margin: 0 auto;
}

.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.metric-card,
.dashboard-panel {
  border: 1px solid rgba(189, 202, 189, 0.45);
  border-radius: 16px;
  background: var(--admin-surface);
  box-shadow: 0 4px 20px rgba(28, 67, 46, 0.04);
}

.metric-card {
  display: grid;
  min-height: 238px;
  align-content: start;
  gap: 20px;
  padding: 24px;
}

.metric-card__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--admin-muted);
  font-size: 16px;
  font-weight: 600;
}

.metric-card__icon,
.dashboard-panel__icon {
  display: inline-grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 19px;
  font-weight: 700;
}

.metric-card__icon--green,
.dashboard-panel__icon--green {
  background: var(--admin-primary-soft);
  color: var(--admin-primary);
}

.metric-card__icon--orange,
.dashboard-panel__icon--orange {
  background: #fff4df;
  color: #d98200;
}

.metric-card__value {
  min-height: 64px;
  color: var(--admin-ink);
  font-size: 44px;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1.25;
}

.metric-card__hint {
  color: var(--admin-muted);
  font-size: 14px;
}

.metric-card__hint--warning {
  color: #b36b00;
}

.dashboard-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);
  gap: 16px;
  align-items: stretch;
}

.dashboard-panel {
  min-width: 0;
  padding: 24px;
}

.dashboard-panel--orders {
  min-height: 540px;
}

.dashboard-side-grid {
  display: grid;
  gap: 16px;
}

.dashboard-panel--warning,
.dashboard-panel--consultation {
  min-height: 262px;
}

.dashboard-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.dashboard-panel__header h2 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  color: var(--admin-ink);
  font-size: 20px;
  line-height: 1.4;
}

.dashboard-panel__header p {
  margin: 8px 0 0;
  font-size: 13px;
}

.dashboard-panel__icon {
  width: 30px;
  height: 30px;
  font-size: 17px;
}

.dashboard-panel__status,
.dashboard-panel__link {
  flex: 0 0 auto;
  color: var(--admin-primary-deep);
  font-size: 13px;
  font-weight: 600;
}

.dashboard-panel__status {
  color: var(--admin-muted);
}

.dashboard-table-placeholder {
  overflow: hidden;
  border: 1px solid rgba(189, 202, 189, 0.35);
  border-radius: 10px;
}

.dashboard-table-placeholder__head {
  display: grid;
  grid-template-columns: 1.1fr 1.7fr 1.1fr 0.9fr 0.9fr;
  gap: 12px;
  padding: 14px 16px;
  background: var(--admin-surface-low);
  color: var(--admin-muted);
  font-size: 14px;
  font-weight: 600;
}

.empty-state {
  display: grid;
  min-height: 160px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: var(--admin-muted);
  text-align: center;
}

.empty-state--table {
  min-height: 360px;
}

.empty-state__mark {
  display: inline-grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 50%;
  background: var(--admin-surface-low);
  color: var(--admin-outline);
  font-size: 21px;
}

.empty-state strong {
  color: var(--admin-ink);
  font-size: 16px;
}

.empty-state p {
  max-width: 34ch;
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
}

@media (max-width: 1100px) {
  .dashboard-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dashboard-main-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-side-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .dashboard-stats,
  .dashboard-side-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-table-placeholder {
    overflow-x: auto;
  }

  .dashboard-table-placeholder__head {
    min-width: 620px;
  }
}
</style>
